import React from 'react'
import { FormContext, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'

import { ColorSpecification, PreviewPage } from 'components'
import { Header } from './components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'
import useTrailStep from 'hooks/useTrailStep'

import theme from 'theme'
import schema from './schema'
import * as service from 'service'
import useStyles from './styles'

const SettingsForm = ({ portalTheme, refresh, setLoading }) => {
  const snackbar = useSnackbar()
  const classes = useStyles()

  const { handleNext, setNextDisabled } = useTrailStep()

  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      primaryColor: portalTheme?.primaryColor || theme.palette.primary.main,
      primaryFontColor:
        portalTheme?.primaryFontColor || theme.palette.common.white,
      secondaryColor:
        portalTheme?.secondaryColor || theme.palette.primary.hover,
      secondaryFontColor:
        portalTheme?.secondaryFontColor || theme.palette.common.white,
      pageTitle: portalTheme?.pageTitle || '',
      pageSubtitle: portalTheme?.pageSubtitle || '',
    },
  })

  const { handleSubmit } = formMethods

  const { mixpanel } = helpers

  const mixpanelTrack = () => {
    mixpanel.track('Personalização do Portal da Privacidade', 'Personalizar', {
      action: 'salvar_config_canal',
    })
  }

  const onSubmit = async (data) => {
    try {
      setLoading(true)
      setNextDisabled(true)

      await service.dponet.privacyPortal.postTheme(data)
      snackbar.open({
        message: 'Tema salvo com sucesso!',
        variant: 'success',
      })
      refresh()
      mixpanelTrack()
      handleNext()
    } catch (error) {
      console.error(error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
      setNextDisabled(false)
    }
  }

  return (
    <>
      <FormContext {...formMethods}>
        <form id="custom-colors-form" onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} className={classes.colorPickers}>
            <Grid item xs={12} md={5}>
              <Header />
              <ColorSpecification
                titleName="Especificação da primeira cor"
                subtitleName="(Cabeçalho e rodapé)"
                buttonMainName="Primeira Cor"
                buttonFontName="Primeira Fonte"
                controlMainName="primaryColor"
                controlFontName="primaryFontColor"
              />
              <ColorSpecification
                titleName="Especificação da segunda cor"
                subtitleName="(Cards, botões)"
                buttonMainName="Segunda Cor"
                buttonFontName="Segunda Fonte"
                controlMainName="secondaryColor"
                controlFontName="secondaryFontColor"
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <PreviewPage />
            </Grid>
          </Grid>
        </form>
      </FormContext>
    </>
  )
}

SettingsForm.propTypes = {
  portalTheme: PropTypes.shape({
    primaryColor: PropTypes.string,
    primaryFontColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    secondaryFontColor: PropTypes.string,
  }),
  refresh: PropTypes.func.isRequired,
}

export default SettingsForm
